import { createSSRSafeStorage } from '../utils/createSSRSafeStorage';

const ACTIVE_ACCOUNT_KEY = 'RCID';
const FEATURE_ENABLED_KEY = 'FEATURE_ENABLED';

// SSR-safe check for browser environment
const isBrowser = typeof window !== 'undefined';

// Use sessionStorage in browser, memory storage for SSR
const storage = createSSRSafeStorage(isBrowser ? sessionStorage : undefined);

export const ResourceStorage = {
  // Active Account - Use session storage to avoid cross-tab issues
  getActiveResource: () => {
    return storage.getItem(ACTIVE_ACCOUNT_KEY) ?? undefined;
  },
  setActiveResource: (accountId: string) => {
    storage.setItem(ACTIVE_ACCOUNT_KEY, accountId);
  },
  clearActiveResource: () => {
    storage.removeItem(ACTIVE_ACCOUNT_KEY);
  },
  setMUSEnabled: (enabled: boolean) => {
    storage.setItem(FEATURE_ENABLED_KEY, enabled.toString());
  },
  MUSEnabled: () => {
    return storage.getItem(FEATURE_ENABLED_KEY) === 'true';
  },
};
